import React, { Component } from "react";
import ReactDOM from "react-dom";
import "./AutoSuggestion.css";

class AutoSuggestion extends Component {
  constructor(props, context) {
    super(props, context);
    this.focusInput = this.focusInput.bind(this);
    this.currentFocus = -1;
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    this.focusInput();
    document.addEventListener(
      "keydown",
      this.handleAutosuggestionKeydown,
      false
    );
    document.addEventListener('mousedown', this.handleClickOutside);
  };

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  focusInput = () => {
    this.autoSuggestionInput.focus();
  };

  handleAutosuggestionKeydown = event => {
    if (ReactDOM.findDOMNode(this).contains(event.target)) {
      let autoCompleteNode = document.getElementById("autosuggestion-list");
      if (autoCompleteNode)
        autoCompleteNode = autoCompleteNode.getElementsByClassName(
          "auto-suggestion-item"
        );
      if (event.keyCode === 40) {
        /*If the arrow DOWN key is pressed,
        increase the currentFocus variable:*/
        this.currentFocus++;
        /*and and make the current item more visible:*/
        this.addActive(autoCompleteNode);
      } else if (event.keyCode == 38) {
        //up
        /*If the arrow UP key is pressed,
        decrease the currentFocus variable:*/
        this.currentFocus--;
        /*and and make the current item more visible:*/
        this.addActive(autoCompleteNode);
      } else if (event.keyCode == 13) {
        /*If the ENTER key is pressed, prevent the form from being submitted,*/
        event.preventDefault();
        if (this.currentFocus > -1) {
          /*and simulate a click on the "active" item:*/
          if (autoCompleteNode) autoCompleteNode[this.currentFocus].click();
        }
      }
    }
  };

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.props.hideSuggestion) {
      this.props.closeSuggestion();
    }
  }

  addActive = autoCompleteNode => {
    /*a function to classify an item as "active":*/
    if (!autoCompleteNode) return false;
    /*start by removing the "active" class on all items:*/
    this.removeActive(autoCompleteNode);
    if (this.currentFocus >= autoCompleteNode.length) this.currentFocus = 0;
    if (this.currentFocus < 0) this.currentFocus = autoCompleteNode.length - 1;
    /*add class "autocomplete-active":*/
    autoCompleteNode[this.currentFocus].classList.add("autocomplete-active");
    this.ensureActiveItemVisible();
  };

  removeActive = autoCompleteNode => {
    /*a function to remove the "active" class from all autocomplete items:*/
    for (var i = 0; i < autoCompleteNode.length; i++) {
      autoCompleteNode[i].classList.remove("autocomplete-active");
    }
  };

  ensureActiveItemVisible() {
    let itemComponent = document.getElementsByClassName(
      "autocomplete-active"
    )[0];
    if (itemComponent) {
      ReactDOM.findDOMNode(itemComponent).scrollIntoView({
        behavior: "smooth"
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener(
      "keydown",
      this.handleAutosuggestionKeydown,
      false
    );
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  render() {
    const { className, children, icon, autoSuggestionResults, handleClick, ...other } = this.props;

    return (
      <div className={"ui-auto-suggestion " + className + ((icon) ? " icon" : "") }>
        {(icon) ? 
          <div class="ui-auto-suggestion__icon">
            <img src={icon} onClick={this.focusInput} />
          </div>
        : null }
        <input
          ref={input => (this.autoSuggestionInput = input)}
          type="text"
          {...other}
          className={this.props.inValid}
        />

        <div id="autosuggestion-list" className="auto-suggestion-items" ref={this.setWrapperRef}>
          {autoSuggestionResults.length > 0 ? (
            autoSuggestionResults.map(suggestedItemObject => (
              <div
                className="auto-suggestion-item"
                onClick={() => handleClick(suggestedItemObject)}
              >
                <div className="item-title">{suggestedItemObject.title}</div>
                {suggestedItemObject.id ? (
                  <div className="item-id">ID {suggestedItemObject.id}</div>
                ) : null}
                {suggestedItemObject.email ? (
                  <div className="item-id">{suggestedItemObject.email}</div>
                ) : null}
              </div>
            ))
          ) : (this.props.value !== null && this.props.value !== "" && !this.props.hideNoResults) ? (
            <div className="auto-suggestion-item">No Results Found</div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default AutoSuggestion;



// WEBPACK FOOTER //
// ./src/components/UI/AutoSuggestion/AutoSuggestion.js